module.exports.publicEnvironmental = { DOMAIN: 'DOMAIN' };
